module.exports = __webpack_public_path__ + "img/bg.2f795934.jpg";